export default __webpack_public_path__ + "static/media/Ellipse 73.0760128d.svg";